import { makeListRequest } from '@/business/apiTreatment/request/makeQueryParams';

const myQueryParam = makeListRequest({
  useEntities: true,
});

function endedLimitFilter({
  search,
  page,
  pageSize,
  entities,
  sort,
  sortBy,
  attributesObj,
  dateMin,
  dateMax,
}) {
  const attributes = myQueryParam({
    search,
    page,
    pageSize,
    entities,
    sort,
    sortBy,
    attributesObj,
    dateMin,
    dateMax,
  });

  let returnedAttributes = attributes;

  if (attributesObj.list_params && attributesObj.list_params.values) {
    const tmp = attributesObj.list_params.values
      .map((param) => {
        const attr = attributesObj[param.origin];
        return attr ? { [param.transformed]: attr.values.join(',') } : {};
      })
      .reduce((acc, item) => ({ ...acc, ...item }), {});
    returnedAttributes = {
      ...returnedAttributes,
      ...tmp,
    };
  }

  return returnedAttributes;
}

export default endedLimitFilter;
